import { render, staticRenderFns } from "./BoxUpdate.vue?vue&type=template&id=7ecc166d&"
import script from "./BoxUpdate.vue?vue&type=script&lang=ts&"
export * from "./BoxUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports